/*
 * Copyright (c) 2021 - Indigen Solutions
 * Authors:
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { groupBy, isEmpty } from "lodash";

export const parseValueWithUnitComparisonQuery = (distribution, fieldName) => {
    if (distribution && distribution.numberValue) {
        return {
            [`${fieldName}Value`]: `${distribution.numberValue},${distribution.condition}`,
            [`${fieldName}Unit`]: distribution.unit ? distribution.unit : null,
        };
    } else {
        return {
            [`${fieldName}Value`]: null,
            [`${fieldName}Unit`]: null,
        };
    }
};

export const parseArrayQuery = query => {
    return query && !isEmpty(query) ? query.toString() : null;
};

export const parseQuery = (query, panoramaQuery, displayedSubjects = []) => {
    const brochureAndIdccBySubtype = groupBy(panoramaQuery.brochureAndIdccValue, a => a.subtype);
    const brochure = brochureAndIdccBySubtype.brochure ? brochureAndIdccBySubtype.brochure : null;
    const idcc = brochureAndIdccBySubtype.idcc ? brochureAndIdccBySubtype.idcc : null;
    return {
        ...query,
        ...panoramaQuery,
        brochure: brochure ? brochure.map(b => b.suggestion).toString() : null,
        idcc: idcc ? idcc.map(b => b.suggestion).toString() : null,
        csps: parseArrayQuery(panoramaQuery.csps),
        displayedSubjects: parseArrayQuery(displayedSubjects.map(subject => subject.code)),
        insurerCodes: panoramaQuery.insurerCodes ? panoramaQuery.insurerCodes : null,
        guarantees: panoramaQuery.guarantees ? panoramaQuery.guarantees : null,
        insuranceType: panoramaQuery.insuranceType ? panoramaQuery.insuranceType : null,
        des: panoramaQuery.des ? panoramaQuery.des : null,
        excludedSubjects: parseArrayQuery(panoramaQuery.excludedSubjects),
        ...parseValueWithUnitComparisonQuery(panoramaQuery.rateDistributionEmployee, "employee"),
        ...parseValueWithUnitComparisonQuery(panoramaQuery.rateDistributionEmployer, "employer"),
        ...parseValueWithUnitComparisonQuery(panoramaQuery.minimumSeniority, "minimumSeniority"),
        ...parseValueWithUnitComparisonQuery(panoramaQuery.ceiling, "ceiling"),
        ...parseValueWithUnitComparisonQuery(panoramaQuery.floor, "floor"),
        rateValue:
            panoramaQuery.rateValue && panoramaQuery.rateValue.numberValue
                ? `${panoramaQuery.rateValue.numberValue},${panoramaQuery.rateValue.condition}`
                : null,
        brochureAndIdccValue: null,
        rateDistributionEmployer: null,
        rateDistributionEmployee: null,
        minimumSeniority: null,
        ceiling: null,
        floor: null,
    };
};
